// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gGC3","newExpiryDate":"styles_newExpiryDate__1TKb6","footer":"styles_footer__3KEMo"};